import React from "react"
import Body, { BodyProps } from "../../typography/Body"

type FormDescriptionProps = BodyProps & {}

export default function FormDescription({ ...props }: FormDescriptionProps) {
  return <Body size="md" color="dawn" mb="3.7075rem" {...props} />
}
